import React, { useCallback, useEffect, useState } from "react";
import { formatNumber } from "../../../redux/utils";
import { fetchApi, getSector, postApi } from "../../../redux/api";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import { Button, Card, Spinner } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
import "./ReleaseCollectionHTML.css";
export const ReleaseCollectionHTML = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const approval_no = searchParams.get('approval_no');
  
  const [form, setForm] = useState({
    collection_date: "",
    approval_date: "",
    approval_type: "",
    mda_name: "",
    amount: "",
    status: "",
    economic_code: "",
    approval_no: "",
    mda_economic_code: "",
  });
  
  const taday = moment(form.approval_date).format("Do MMMM, YYYY");
  const [signatureInfo, setSignatureInfo] = useState({});
  const [directors, setDirectors] = useState([]);
  const [ccCopies, setCcCopies] = useState([]);

  useEffect(() => {
    if (form.approved_ids) {
      fetchApi(`sign-by-id-new?id=${form.approved_ids}`)
        .then((d) => {
          if (d.success) {
            setSignatureInfo(d?.data[0]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [form.approved_ids]);

  const getCcCopieds = (mda_name) => {
    postApi(`post-cc?query_type=select_mda`, { mda_name })
      .then((data) => {
        if (data.results && data.results.length) {
          setCcCopies(data.results);
          setForm((p) => ({
            ...p,
            copies1: data.results[0],
          }));
        }
      })
      .catch((err) => {
        console.error("Error fetching ccCopies:", err);
      });
  };

  useEffect(() => {
    getSector({}, "select_director", setDirectors);
  }, []);

  const getApprovalCollection = useCallback(() => {
    if (!approval_no) {
      toast.error('Approval number is required');
      return;
    }
    
    setLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "select_by_approval_nos",
        approval_no: approval_no,
      },
    })
      .then((data) => {
        if (data.result && data.result.length) {
          const result = data.result[0];
          setForm(result);
          getCcCopieds(result.mda_name);
        }
      })
      .catch((err) => {
        console.error("Error fetching approval collection:", err);
        toast.error('Failed to load approval data');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [approval_no]);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection]);

  const ignoreMDA = form.mda_name === "Ministry of Finance" || form.mda_name === "Government House";
  const directorName = directors[0]?.name;
  const directorSignature = directors[0]?.imageURL;

  const handleDownloadPDF = () => {
    // Use browser's print dialog with PDF option
    const printWindow = window.open('', '_blank');
    const element = document.getElementById('release-document');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Release Document - ${form.approval_no}</title>
          <style>
            ${getDocumentStyles()}
          </style>
        </head>
        <body>
          ${element.innerHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };

  const getDocumentStyles = () => {
    return `
      body {
        font-family: 'Times New Roman', serif;
        color: #000;
        background: white;
        margin: 0;
        padding: 0;
      }

      .page {
        width: 210mm;
        min-height: 297mm;
        margin: 0 auto;
        background: white;
        padding: 20mm;
        box-sizing: border-box;
      }

      .page-break {
        page-break-before: always;
      }

      .page-content {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .header-section {
        text-align: center;
        margin-bottom: 30px;
      }

      .logo {
        width: 70px;
        height: 50px;
        margin-bottom: 10px;
      }

      .ministry-title {
        font-size: 20px;
        font-weight: bold;
        margin: 10px 0;
      }

      .address, .postal {
        font-style: italic;
        font-size: 12px;
        margin: 5px 0;
      }

      .ref-date-section {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding-bottom: 5px;
      }

      .ref-label {
        font-weight: bold;
        font-size: 12px;
      }

      .ref-number, .date {
        font-weight: bold;
        font-size: 12px;
        text-decoration: underline;
      }

      .addressee {
        width: 50%;
        margin-bottom: 20px;
      }

      .addressee p {
        font-style: italic;
        font-size: 12px;
        margin: 3px 0;
      }

      .subject {
        text-align: center;
        margin: 20px 0;
      }

      .subject h3 {
        text-decoration: underline;
        font-weight: bold;
        font-size: 12px;
      }

      .body-content {
        text-align: justify;
        line-height: 1.5;
        margin-bottom: 30px;
      }

      .body-content p {
        font-size: 12px;
        margin: 15px 0;
      }

      .signature-section {
        margin: 40px 0;
        display: flex;
        justify-content: flex-end;
      }

      .signature-block {
        width: 40%;
        text-align: center;
      }

      .signatory-name, .signatory-title {
        font-size: 12px;
        font-weight: bold;
        margin: 5px 0;
      }

      .cc-section {
        margin-top: 20px;
      }

      .cc-label {
        font-weight: bold;
        font-size: 12px;
        margin-bottom: 10px;
      }

      .cc-list {
        margin-left: 50px;
      }

      .cc-item {
        margin-bottom: 10px;
      }

      .cc-item p {
        font-style: italic;
        font-size: 8px;
        margin: 2px 0;
      }

      .footer-note {
        text-align: center;
        margin: 20px 0;
      }

      .footer-note p {
        font-style: italic;
        font-size: 12px;
      }

      .final-signature {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
      }

      .final-signature-page2 {
        display: flex;
        justify-content: flex-end;
        margin-top: auto;
      }

      .final-signature-block {
        width: 35%;
        text-align: center;
      }

      .signature-image {
        height: 50px;
        width: auto;
        margin-bottom: 10px;
      }

      @media print {
        .page {
          margin: 0;
          width: 100%;
          min-height: auto;
        }
        
        .page-break {
          page-break-before: always;
        }
      }
    `;
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <div className="d-print-none">
        <BackButton />
        <Card border="light" className="bg-white shadow-sm mb-4">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Release Document - {form.approval_no}</h5>
              <div className="d-flex gap-2">
                <Button variant="primary" onClick={handleDownloadPDF}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Download PDF
                </Button>
                <Button variant="secondary" onClick={handlePrint}>
                  <FontAwesomeIcon icon={faPrint} className="me-2" />
                  Print
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>

      <div id="release-document" className="release-document">
        {/* Page 1 */}
        <div className="page">
          <div className="page-content">
            <div className="header-section">
              <img 
                src={require("../../../assets/img/KTSG.png")} 
                alt="KTSG Logo" 
                className="logo"
              />
              <h2 className="ministry-title">MINISTRY OF BUDGET & ECONOMIC PLANNING</h2>
              <p className="address">Old Government House Office Complex, Katsina</p>
              <p className="postal">P.MB 2132, KATSINA</p>
            </div>

            <div className="ref-date-section">
              <div className="ref-section">
                <span className="ref-label">Our Ref: </span>
                <span className="ref-number">{form?.approval_no}</span>
              </div>
              <div className="date-section">
                <span className="date">{taday}</span>
              </div>
            </div>

            <div className="addressee">
              <p>The Accountant General,</p>
              <p>Ministry of Finance,</p>
              <p>Katsina,</p>
            </div>

            <div className="subject">
              <h3>SPECIAL RELEASE OF FUNDS</h3>
            </div>

            <div className="body-content">
              <p>
                I am directed to convey approval for the release of{" "}
                <strong>(N{formatNumber(form.amount)}) only</strong> to{" "}
                {form?.copies1?.officeTitle && form?.copies1?.officeTitle !== null
                  ? form?.copies1?.officeTitle + " "
                  : ""}
                {form?.copies?.officeTitle && form?.copies?.officeTitle !== null
                  ? " payable to the "
                  : ""}{" "}
                {form?.copies?.officeTitle}
                {form.narration}.{" "}
                <strong>
                  The Vote of Charge is{" "}
                  {form.projectType === "payable-to"
                    ? form.send_to_office
                    : form.mda_code}
                  /
                  {form.approval_type === "Recurrent"
                    ? form.economic_code
                    : form.program_code}
                  .
                </strong>
              </p>

              <p>
                This letter is copied to the{" "}
                {ignoreMDA ? null : form?.copies?.officeTitle}{" "}
                {form?.copies1 && form?.copies1?.officeTitle}, the PS, (GHKT),
                the HC (MOF), the Auditor-General, the Office of the
                Auditor-General for the State, and the Director of Main
                Account, Ministry of Finance.
              </p>
            </div>

            <div className="signature-section">
              <div className="signature-block">
                <p className="signatory-name">
                  {directorName || "KABIR ABU BAZARIYE"}
                </p>
                <p className="signatory-title">FOR: HON, COMMISSIONER</p>
              </div>
            </div>

            <div className="cc-section">
              <p className="cc-label">CC:</p>
              <div className="cc-list">
                {!ignoreMDA && form?.copies?.officeTitle && (
                  <div className="cc-item">
                    <p>{form?.copies?.officeTitle},</p>
                    <p>Katsina,</p>
                  </div>
                )}
                {form?.copies1?.officeTitle && (
                  <div className="cc-item">
                    <p>{form?.copies1?.officeTitle},</p>
                    <p>Katsina,</p>
                  </div>
                )}
                <div className="cc-item">
                  <p>The Permanent Secretary,</p>
                  <p>Government House,</p>
                  <p>Katsina,</p>
                </div>
                <div className="cc-item">
                  <p>The Hon. Commissioner,</p>
                  <p>Ministry of Finance,</p>
                  <p>Katsina,</p>
                </div>
                <div className="cc-item">
                  <p>The Auditor General,</p>
                  <p>Office of the Auditor-General for the State,</p>
                  <p>Katsina,</p>
                </div>
                <div className="cc-item">
                  <p>The Director Main-Account,</p>
                  <p>Ministry of Finance,</p>
                  <p>Katsina,</p>
                </div>
                {form.cc === "kirs" && (
                  <div className="cc-item">
                    <p>Board Of Internal Revenue,</p>
                    <p>Katsina</p>
                  </div>
                )}
              </div>
            </div>

            <div className="footer-note">
              <p>Above for your information and awareness, please.</p>
            </div>

            <div className="final-signature">
              {directorSignature && (
                <img 
                  src={directorSignature} 
                  alt="Signature" 
                  className="signature-image"
                />
              )}
              <div className="final-signature-block">
                <p className="signatory-name">
                  {directorName || "KABIR ABU BAZARIYE"}
                </p>
                <p className="signatory-title">FOR: HON, COMMISSIONER</p>
              </div>
            </div>
          </div>
        </div>

        {/* Page 2 - Duplicate with slight variations */}
        <div className="page page-break">
          <div className="page-content">
            <div className="header-section">
              <img 
                src={require("../../../assets/img/KTSG.png")} 
                alt="KTSG Logo" 
                className="logo"
              />
              <h2 className="ministry-title">MINISTRY OF BUDGET & ECONOMIC PLANNING</h2>
              <p className="address">Old Government House Office Complex, Katsina</p>
              <p className="postal">P.MB 2132, KATSINA</p>
            </div>

            <div className="ref-date-section">
              <div className="ref-section">
                <span className="ref-label">Our Ref: </span>
                <span className="ref-number">{form?.approval_no}</span>
              </div>
              <div className="date-section">
                <span className="date">{taday}</span>
              </div>
            </div>

            <div className="addressee">
              <p>The Accountant General,</p>
              <p>Ministry of Finance,</p>
              <p>Katsina,</p>
            </div>

            <div className="subject">
              <h3>SPECIAL RELEASE OF FUNDS</h3>
            </div>

            <div className="body-content">
              <p>
                I am directed to convey approval for the release of{" "}
                <strong>(N{formatNumber(form.amount)}) only</strong> to the{" "}
                {form?.copies1?.officeTitle && form?.copies1?.officeTitle !== null
                  ? form?.copies1?.officeTitle + " "
                  : ""}
                {form?.copies1?.officeTitle && form?.copies1?.officeTitle !== null
                  ? " payable to the "
                  : ""}{" "}
                {form?.copies?.officeTitle}
                {form.narration}.{" "}
                <strong>
                  The Vote of Charge is{" "}
                  {form.projectType === "payable-to"
                    ? form.send_to_office
                    : form.mda_code}
                  /
                  {form.approval_type === "Recurrent"
                    ? form.economic_code
                    : form.program_code}
                  .
                </strong>
              </p>

              <p>
                This letter is copied to the{" "}
                {ignoreMDA ? null : form?.copies?.officeTitle},{" "}
                {form?.copies1 && form?.copies1?.officeTitle}, the PS, (GHKT),
                the HC (MOF), the Auditor-General, the Office of the
                Auditor-General for the State, and the Director of Main
                Account, Ministry of Finance.
              </p>
            </div>

            <div className="final-signature-page2">
              {directorSignature && (
                <img 
                  src={directorSignature} 
                  alt="Signature" 
                  className="signature-image"
                />
              )}
              <div className="final-signature-block">
                <p className="signatory-name">
                  {directorName || "KABIR ABU BAZARIYE"}
                </p>
                <p className="signatory-title">FOR: HON, COMMISSIONERxx</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};